import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

const defaultProps = {
  code: "",
  titleElement: "h2",
  title: ""
};

const Section = ({
  children,
  code = defaultProps.code,
  title = defaultProps.title,
  titleElement = defaultProps.level
}) => {
  const fullTitle = `${code ? `${code}. ` : ""}${title}`;
  return (
    <div>
      {fullTitle && (
        <Typography
          component={titleElement}
          variant={titleElement}
          className="pt-8">
          {fullTitle}
        </Typography>
      )}
      <div className="pb-4">{children}</div>
    </div>
  );
};

Section.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  code: PropTypes.number,
  title: PropTypes.string,
  titleElement: PropTypes.string
};

export default Section;
